import React from 'react';
import './Icons.css';

import Gallery_pic from '../assets/Icons/photo-gallery.png'
import Download from '../assets/Icons/download.png'
import contract from '../assets/Icons/contract.png'
import office from '../assets/Icons/office.png'
import datascience from '../assets/Icons/datascience.png'
import atom from '../assets/Icons/atom.png'
// import pico from '../assets/Icons/medicine.png'

import { Link } from 'react-router-dom';


const Icons = () => {
  return (
    
    <>
    
    <div className="mycontainer container">
    
      <div className="icon">
       
         <Link to="/Gallery">
          <img src={Gallery_pic} alt="Gallery" />
        </Link>
        <p>Gallery</p>
    
      </div>
      
      <div className="icon">
        <Link to="/Downloads">
          <img src={Download} alt="Downloads" />
        </Link>
        <p>Downloads</p>
      </div>
      <div className="icon">
        <Link to="/MOUs">
        <img src={contract} alt="MOUs" />
        </Link>
        <p>MOUs</p>
      </div>
      <div className="icon">
        <Link to="/Conferences">
          <img src={office} alt="MS Office & Window/OS Activation" />
        </Link>
        <p>Conferences</p>
      </div>
      <div className="icon">
        <Link to="/Facultyofsocialscience">
          <img src={datascience} alt="MS Office & Window/OS Activation" />
        </Link>
        <p>Faculty of Social Sciences</p>
      </div>
      <div className="icon">
        <Link to="/FacultyofSciences">
          <img src={atom} alt="Faculty Sciences" />
        </Link>
        <p>Faculty Sciences</p>
      </div>
     
    </div>
    </>
  );
};

export default  Icons;

